const textCommandLibraryCategories = [
  {
    id: 'personal',
    name: 'Personal',
    commands: [
      { match: 'email', description: 'yourname@example.com' },
      { match: 'my email', description: 'yourname@example.com' },
      { match: 'my phone', description: '+1 555 123 4567' },
      { match: 'my name', description: 'Your Name' },
      { match: 'my title', description: 'Your Job Title' },
      { match: 'my company', description: 'Your Company' },
      { match: 'my website', description: 'https://example.com' },
      { match: 'my address', description: '123 Main Street, City, State, ZIP' },
      { match: 'calendar link', description: 'You can book a time with me here: https://calendly.com/yourname' },
      { match: 'zoom link', description: 'Here is the Zoom link: https://zoom.us/j/your-meeting-id' },
      { match: 'linkedin profile', description: 'https://www.linkedin.com/in/yourname' },
    ],
  },
  {
    id: 'email',
    name: 'Email',
    commands: [
      { match: 'email greeting', description: 'Hi there,\n\n' },
      { match: 'email signoff', description: 'Best regards,\nYour Name' },
      { match: 'warm signoff', description: 'Warmly,\nYour Name' },
      { match: 'thanks signoff', description: 'Thanks,\nYour Name' },
      { match: 'quick follow up', description: 'Just following up on this. Please let me know when you have a chance.' },
      { match: 'gentle reminder', description: 'Gentle reminder on this. Happy to help if anything is blocked.' },
      { match: 'meeting follow up', description: 'Thanks for the time today. Here are the next steps we discussed:\n\n1. \n2. \n3. ' },
      { match: 'reply received', description: 'Thanks, received. I will review this and get back to you shortly.' },
      { match: 'out of office', description: 'Thanks for your message. I am currently out of office and will respond when I return.' },
      { match: 'intro request', description: 'Would you be open to making an introduction? I can send a short forwardable blurb.' },
      { match: 'forwardable blurb', description: 'Forwardable blurb:\n\nHi, I am Your Name. I work on [brief context]. I would love to connect about [reason].' },
      { match: 'decline politely', description: 'Thanks for thinking of me. I am going to pass for now, but I appreciate you reaching out.' },
      { match: 'schedule ask', description: 'Could you share a few times that work for you this week?' },
      { match: 'schedule confirm', description: 'That works for me. I will send a calendar invite.' },
      { match: 'attachment note', description: 'I have attached the file here. Please let me know if you have any trouble opening it.' },
    ],
  },
  {
    id: 'meetings',
    name: 'Meetings',
    commands: [
      { match: 'meeting agenda', description: 'Agenda:\n1. Context\n2. Decisions needed\n3. Open questions\n4. Next steps' },
      { match: 'meeting notes', description: 'Notes:\n\nDecisions:\n- \n\nAction items:\n- \n\nOpen questions:\n- ' },
      { match: 'action items', description: 'Action items:\n- Owner: , Task: , Due: \n- Owner: , Task: , Due: ' },
      { match: 'decision log', description: 'Decision: \nReason: \nOwner: \nDate: ' },
      { match: 'parking lot', description: 'Parking lot:\n- ' },
      { match: 'standup update', description: 'Yesterday: \nToday: \nBlockers: ' },
      { match: 'meeting summary', description: 'Summary:\n- \n\nNext steps:\n- ' },
      { match: 'running late', description: 'I am running a few minutes late and will join shortly.' },
      { match: 'need to drop', description: 'I need to drop now. Please send me any action items after the call.' },
      { match: 'can you repeat', description: 'Could you repeat that last point?' },
      { match: 'one sec', description: 'One second, I am pulling that up now.' },
      { match: 'takeaway', description: 'The main takeaway is: ' },
    ],
  },
  {
    id: 'support',
    name: 'Support',
    commands: [
      { match: 'support intro', description: 'Thanks for reaching out. I am happy to help.' },
      { match: 'support need details', description: 'Could you share a bit more detail about what happened, including any error messages or screenshots?' },
      { match: 'support troubleshooting', description: 'Please try these steps:\n1. Refresh the page.\n2. Sign out and sign back in.\n3. Clear your browser cache.\n4. Try again in an incognito window.' },
      { match: 'support resolved', description: 'This should be resolved now. Please try again and let me know if you still see the issue.' },
      { match: 'support escalation', description: 'I am escalating this to our team for a deeper look. I will update you as soon as I have more information.' },
      { match: 'support apology', description: 'Sorry for the trouble here. I understand how frustrating that is.' },
      { match: 'support workaround', description: 'As a temporary workaround, you can try the following: ' },
      { match: 'support closing', description: 'I am going to close this for now, but you can reply here if anything else comes up.' },
      { match: 'bug report', description: 'Bug report:\nExpected: \nActual: \nSteps to reproduce:\n1. \n2. \nEnvironment: ' },
      { match: 'feature request', description: 'Feature request:\nProblem: \nSuggested solution: \nImpact: ' },
    ],
  },
  {
    id: 'sales',
    name: 'Sales',
    commands: [
      { match: 'sales intro', description: 'Thanks for your interest. I would love to learn more about what you are trying to solve.' },
      { match: 'discovery questions', description: 'A few quick questions:\n1. What problem are you trying to solve?\n2. What are you using today?\n3. What would success look like?\n4. What is your timeline?' },
      { match: 'pricing response', description: 'Pricing depends on usage and team size. Happy to share the best option after I understand your needs.' },
      { match: 'demo offer', description: 'Would it be helpful to schedule a short demo? You can book a time here: https://calendly.com/yourname' },
      { match: 'proposal intro', description: 'Based on our conversation, here is a proposal for how we can help.' },
      { match: 'trial check in', description: 'How is the trial going so far? Any questions or blockers I can help with?' },
      { match: 'renewal note', description: 'Your renewal is coming up soon. Would you like to review usage, pricing, or plan options?' },
      { match: 'breakup email', description: 'I have not heard back, so I will close the loop for now. If this becomes a priority later, I would be happy to reconnect.' },
      { match: 'customer proof', description: 'Teams use us to save time, reduce repeated typing, and keep communication consistent across workflows.' },
      { match: 'next step sales', description: 'The next best step is to confirm scope, timeline, and who needs to be involved in the decision.' },
    ],
  },
  {
    id: 'productivity',
    name: 'Productivity',
    commands: [
      { match: 'todo list', description: 'Todo:\n- \n- \n- ' },
      { match: 'priority list', description: 'Priorities:\n1. Must do: \n2. Should do: \n3. Could do: ' },
      { match: 'daily plan', description: 'Daily plan:\nTop priority: \nMeetings: \nTasks: \nFollow-ups: ' },
      { match: 'weekly review', description: 'Weekly review:\nWins: \nLessons: \nOpen loops: \nNext week: ' },
      { match: 'brain dump', description: 'Brain dump:\n- ' },
      { match: 'quick note', description: 'Quick note: ' },
      { match: 'remember this', description: 'Remember: ' },
      { match: 'open question', description: 'Open question: ' },
      { match: 'next steps', description: 'Next steps:\n1. \n2. \n3. ' },
      { match: 'status update', description: 'Status: \nProgress: \nRisks: \nNext: ' },
      { match: 'blocked update', description: 'I am blocked by: \nNeeded to unblock: \nOwner: ' },
      { match: 'handoff note', description: 'Handoff:\nContext: \nCurrent state: \nNext step: \nRisks: ' },
    ],
  },
  {
    id: 'writing',
    name: 'Writing',
    commands: [
      { match: 'rewrite clearer', description: 'Rewrite this to be clearer and more concise: ' },
      { match: 'rewrite friendly', description: 'Rewrite this in a friendly, professional tone: ' },
      { match: 'rewrite direct', description: 'Rewrite this to be direct and easy to act on: ' },
      { match: 'summarize this', description: 'Summarize this in 3 bullet points: ' },
      { match: 'make bullets', description: 'Turn this into concise bullet points: ' },
      { match: 'make email', description: 'Turn this into a polished email: ' },
      { match: 'make slack', description: 'Turn this into a short Slack message: ' },
      { match: 'make title', description: 'Write 5 concise title options for this: ' },
      { match: 'proofread', description: 'Proofread this for grammar, clarity, and tone: ' },
      { match: 'short answer', description: 'Short answer: ' },
      { match: 'long answer', description: 'Detailed answer: ' },
      { match: 'explain simply', description: 'Explain this in simple terms: ' },
    ],
  },
  {
    id: 'developer',
    name: 'Developer',
    commands: [
      { match: 'commit message', description: 'Write a concise commit message for: ' },
      { match: 'pull request summary', description: 'PR summary:\nWhat changed:\n- \n\nWhy:\n- \n\nTesting:\n- ' },
      { match: 'code review note', description: 'Review note:\nIssue: \nImpact: \nSuggested fix: ' },
      { match: 'bug repro', description: 'Reproduction steps:\n1. \n2. \n3. \nExpected: \nActual: ' },
      { match: 'debug log', description: 'Debug log:\nInput: \nObserved behavior: \nHypothesis: \nNext check: ' },
      { match: 'test case', description: 'Test case:\nGiven: \nWhen: \nThen: ' },
      { match: 'release note', description: 'Release note:\n- Added: \n- Fixed: \n- Changed: ' },
      { match: 'api request', description: 'API request:\nEndpoint: \nMethod: \nPayload: \nExpected response: ' },
      { match: 'incident update', description: 'Incident update:\nImpact: \nCurrent status: \nMitigation: \nNext update: ' },
      { match: 'root cause', description: 'Root cause: \nContributing factors: \nFix: \nPrevention: ' },
    ],
  },
  {
    id: 'legal',
    name: 'Legal',
    commands: [
      { match: 'not legal advice', description: 'This is for general information only and is not legal advice.' },
      { match: 'confidential note', description: 'Confidential: please do not forward without permission.' },
      { match: 'contract note', description: 'Contract note:\nClause: \nConcern: \nProposed change: ' },
      { match: 'client memo', description: 'Client memo:\nIssue: \nFacts: \nAnalysis: \nRecommendation: ' },
      { match: 'case summary', description: 'Case summary:\nParties: \nIssue: \nHolding: \nReasoning: ' },
      { match: 'follow counsel', description: 'Please confirm this with your legal counsel before taking action.' },
      { match: 'privileged', description: 'Attorney-client privileged and confidential.' },
      { match: 'redline request', description: 'Please review the redline and let me know which changes you accept.' },
    ],
  },
  {
    id: 'symbols',
    name: 'Symbols',
    commands: [
      { match: 'arrow right', description: '->' },
      { match: 'arrow left', description: '<-' },
      { match: 'double arrow', description: '=>' },
      { match: 'check mark', description: '[x]' },
      { match: 'empty checkbox', description: '[ ]' },
      { match: 'bullet point', description: '- ' },
      { match: 'number one', description: '1. ' },
      { match: 'quote block', description: '> ' },
      { match: 'code ticks', description: '``' },
      { match: 'divider line', description: '---' },
    ],
  },
];

export default textCommandLibraryCategories;
